import Logo from "../../img/logo-white.svg";
import { IoTicket } from "react-icons/io5";
import { Link, animateScroll as scroll } from "react-scroll";

function HeaderInternal() {
    return (
        <>
            <header className="py-3 bg-[#E7E9EC]">
                <div className="container px-3 mx-auto flex justify-between items-center">
                    <a href="/">
                        <img src={Logo} alt="Business Wisdom Summit" className="w-[100px]"/>
                    </a>
                    <nav>
                        <ul className="flex gap-4">
                            <li><a href="/">Головна</a></li>
                        </ul>
                    </nav>
                </div>

            </header>
        </>
    )
}

export default HeaderInternal;